// eslint-disable-next-line no-shadow
export enum PricingModalSource {
	DEFAULT = '',
	STUDIO = 'studio',
	CANVAS = 'canvas',
	PRICING = 'pricing',
	SUBSCRIPTION = 'subscription',
	DO_MORE = 'do_more',
	FREE_VOICE_SCRIPT = 'free_voice_script',
	FREE_NARRATOR_AUDIO = 'free_narrator_audio',
	CHARACTER_GENERATOR = 'character-generator',
}
